module.exports = __webpack_public_path__ + "static/rb-logo-5db797482b1a54fd3fed6594a68af10c.png";